export default class Utils {

    static onReady(callback) {
        if (document.readyState !== 'loading') {
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    }

    static getOffsetTop(element) {
        let offsetTop = 0;
        while (element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }

        return offsetTop;
    }

    static daysToMilliseconds(days) {
        // 👇️        hour  min  sec  ms
        return days * 24 * 60 * 60 * 1000;
    }

    static parent(el, selector) {
        while ((el = el.parentNode) && el !== document) {
            if (!selector || el.matches(selector)) {
                return el;
            }
        }

        return null;
    }

    static request(url, method = 'GET') {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open(method, url, true);

            request.onload = function () {
                if (this.status >= 200 && this.status < 400) {
                    resolve(this.response);
                } else {
                    reject(false);
                }
            };

            request.onerror = () => reject(false);

            request.send();
        })
    }

    static async jsonRequest(url) {
        return this.request(url)
            .then(response => JSON.parse(response))
            .catch(console.error);
    }

    static throttle(callback, wait, immediate = false) {
        let timeout = null
        let initialCall = true

        return function () {
            const callNow = immediate && initialCall
            const next = () => {
                callback.apply(this, arguments)
                timeout = null
            }

            if (callNow) {
                initialCall = false
                next()
            }

            if (!timeout) {
                timeout = setTimeout(next, wait)
            }
        }
    }

    static generateUniqueIdentifier(prefix = '') {
        const identifier = Math.round(new Date().getTime() + (Math.random() * 100));

        if (prefix !== '') {
            return prefix + '-' + identifier;
        }

        return identifier;
    }

}